export const UncaughtInPromise = 'Uncaught (in promise):';
export const ResponseLabel = {
  HttpErrorResponse: 'HttpErrorResponse',
  HttpResponse: 'HttpResponse',
};
